<router-outlet *ngIf="initialized$ | async; else loading"></router-outlet>

<ng-template #loading>
  <dlr-loading></dlr-loading>
</ng-template>
